import { Box, Typography } from "@mui/material";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import CaseStudyCard from "../../components/cards/CaseStudyCard";
import { caseStudiesData } from "../../data/CaseStudyCard";
import Orangelogo from "../../assets/images/Orangelogo.png";
import Knowmorebtn from "../../components/button/Knowmorebtn";
import { useTheme } from "@mui/material/styles";

const CaseStudies = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        maxWidth: { xs: "100%", sm: "1440px" },
        margin: "0 auto",
        width: "100%",
        marginTop: "4rem",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        padding: { xs: "0rem 1.8rem", sm: "0rem 4rem" },
      }}
    >
      {/* Left Section - Content */}
      <Box
        sx={{
          width: { xs: "100%", sm: "40%" },
        }}
      >
        <Box
          sx={{
            width: "4rem",
            marginTop: { xs: "2rem", sm: "4rem" },
          }}
        >
          <img src={Orangelogo} alt="" width="100%" />
        </Box>
        <Typography
          sx={{
            color: "rgba(35, 35, 37, 1)",
            fontFamily: "Montserrat",
            fontSize: { xs: "0.8rem", sm: "1rem" },
            marginTop: "0.8rem",
          }}
        >
          HOW WE HAVE HELPED OUR CLIENTS
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: { xs: "1.4rem", sm: "1.6rem" },
            fontWeight: "500",
            marginTop: "1.2rem",
          }}
        >
          Case <span style={{ color: "rgba(255, 102, 0, 1)" }}>Studies</span>
        </Typography>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            marginTop: "1.2rem",
            marginBottom: "1.2rem",
          }}
        >
          Discover how our expertise delivered measurable results and
          transformed businesses.
        </Typography>
        <Knowmorebtn content="Read more" link="/casestudies" />
      </Box>

      {/* Right Section - Slider */}
      <Box
        sx={{
          width: { xs: "100%", sm: "60%" },
          position: "relative",
          marginTop: { xs: "2rem", sm: "0rem" },
          pl: { xs: 0, sm: 3, md: 18 },
          height: "auto",
          "&::after": {
            content: '""',
            position: "absolute",
            [theme.breakpoints.down("sm")]: {
              bottom: 0,
              left: 0,
              width: "100%",
              height: "150px",
              background: "",
            },
            [theme.breakpoints.up("sm")]: {
              right: 0,
              top: 0,
              height: "100%",
              width: "100px",
              background: "linear-gradient(to right, transparent, #ecebeb)",
            },
            pointerEvents: "none",
            zIndex: 1,
          },
        }}
      >
        <Swiper
          spaceBetween={20}
          grabCursor={true}
          direction="horizontal"
          style={{
            height: "100%",
            padding: "20px 0",
          }}
          breakpoints={{
            0: {
              slidesPerView: 1.2,
              direction: "horizontal",
              spaceBetween: 15,
              centeredSlides: true,
            },
            600: {
              slidesPerView: 1.2,
              direction: "horizontal",
              spaceBetween: 20,
              centeredSlides: false,
            },
            1024: {
              slidesPerView: 2.2,
              direction: "horizontal",
              spaceBetween: 20,
              centeredSlides: false,
            },
          }}
        >
          {caseStudiesData.map((study) => (
            <SwiperSlide
              key={study.id}
              style={{
                display: "flex",
                height: "100%",
              }}
            >
              <CaseStudyCard
                image={study.image}
                title={study.title}
                description={study.description}
                link={study.link}
                sx={{ flex: 1 }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
};

export default CaseStudies;
